import React, {useState, useEffect, useContext, useRef} from 'react';
import { InfoWindowHook } from './InfoWindowHook';
import { useSetRoute } from '_context/commonHooks';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

const ClusterInfoWindow = (props) => {
    const [markerInfoDisplay, setMarkerInfoDisplay] = useState(false)
    const [poiName, setPoiName] = useState('')
    const [category, setCategory] = useState('')
    const [phone, setPhone] = useState('')
    const [homePage, setHomePage] = useState('')
    const [photoURL, setPhotoURL] = useState('')
    const [roadAddress, setRoadAddress] = useState('')
    const [landAddress, setLandAddress] = useState('')
    const {setDisplay, location} = InfoWindowHook(props, 22, 190, 302, 170, 'ClusterInfoWindow'); 
    const [setRoute] = useSetRoute()
    const [markerInfo, setMarkerInfo] = useState()
 
    useEffect(() => {
        if(props.marker){
            setMarkerInfoDisplay(false)
        }
    }, [props.marker])

    useEffect(() => {
        if(markerInfo){
            let attr = markerInfo.attribute
            setPoiName(attr.name)
            setCategory(attr.category.masterName)
            attr.phones && attr.phones.normal ? setPhone(attr.phones.normal) : setPhone('');
            attr.phones && attr.phones.representation ? setPhone(attr.phones.representation) : setPhone(phone)
            attr.extension && attr.extension.homepageURL ? setHomePage(attr.extension.homepageURL) : setHomePage('')
            setRoadAddress(attr.address.siDo + " " + attr.address.siGunGu + " " + attr.address.street + " " + attr.address.streetNumber)
            setLandAddress(attr.address.eupMyeonDong + " " + attr.address.houseNumber)
            attr.extension && attr.extension.photoURL ? setPhotoURL(attr.extension.photoURL) : setPhotoURL('')
        }
    }, [markerInfo])

    const setWinRoute=(target,keyword,point,mode)=>{
        setRoute(target,keyword,point,mode); 
    }

    return (
        <div className="lyBox innerMap botLeft" style={{height:170, left:location.x, top:location.y, display:location.display, opacity:location.opacity}}>
            <div style={{display:!markerInfoDisplay?'block':'none', paddingTop:'30px', height:160}}>
                <OverlayScrollbarsComponent>
                    <div style={{display:!markerInfoDisplay?'block':'none',  height:140}}>
                    {props.marker && props.marker.getAllMarkers && props.marker.getAllMarkers().map((row,i)=>
                        <li style={{cursor:'pointer', paddingLeft:'10px'}} key={i} onClick={(e) => {setMarkerInfo(row); setMarkerInfoDisplay(true)}}>{row.attribute.name}</li>
                    )}
                    </div>
                </OverlayScrollbarsComponent>
            </div>
            <div style={{display:markerInfoDisplay?'block':'none'}}>
                <div className="title">
                    {/* <button className="btnsSch ic_bookmark" title="즐겨찾기">즐겨찾기</button> */}
                    {poiName}
                </div>
                <div className="info">
                    <span className="kind">{category}</span>
                    <span className="tel">{phone}</span>
                    <a href={homePage} target="_blank" className="web" style={{display:(homePage==''?'none':'inline')}}>홈페이지</a>
                </div>
                <div className="address">{roadAddress}</div>
                <div className="address">
                    <span className="jibun">지번</span>
                    {landAddress}
                </div>
                <div className="departureArrival">
                    <button className="ic_start" onClick={()=>setWinRoute("start",poiName,markerInfo.attribute.point)}><span className="btnsSch"></span><span>출발</span></button>
                    <button className="ic_waypoint" onClick={()=>setWinRoute("wayPoints",poiName,markerInfo.attribute.point, 'add')}><span className="btnsSch"></span><span>경유지</span></button>
                    <button className="ic_arrival" onClick={()=>setWinRoute("end",poiName,markerInfo.attribute.point)}><span className="btnsSch"></span><span>도착</span></button>
                </div>
                <img src={photoURL} alt="" className="photo"></img>
                </div>
            <button className="btnsSch btnClose" onClick={(e) => {setDisplay('none'); props.close(e)}}>닫기</button>
	    </div>
    );
}

export default ClusterInfoWindow